import type { ICreateAppRatingCmd } from "@/data/commands/feedback/CreateAppRatingCmd";
import { Factory } from "@/data/dao/Factory";
import { FeedbackDao } from "@/data/dao/service/FeedbackDao";

import { logError } from "@/shared/logging/errors";
import { Ripple } from "@/shared/ui/Ripple";

import { BaseController } from "@/app/controller/BaseController";
import { StarRating } from "@/app/elements/StarRating";
import { trans } from "@/app/localization/Trans";
import { Popup } from "@/app/ui/Popup";

export class AppRateController extends BaseController {
    public onGoBack?: { () };

    private $rateForm: JQuery;
    private $saveBtn: JQuery;

    private $descriptionInput: JQuery;
    private rating: StarRating;

    constructor() {
        super("apprate");

        const hdr = $('<div class="head"><div class="title">' + trans.help.rateTitle + "</div></div>").appendTo(
            this.$view
        );
        Ripple.bind($('<a class="action left" href="#"><i class="fal fa-arrow-left"></i></a>'))
            .prependTo(hdr)
            .click((e) => {
                e.preventDefault();
                if (this.onGoBack !== undefined) this.onGoBack();
            });

        const scrollable = $('<div class="scrollable" />').appendTo(this.$view);
        scrollable.append(
            '<div class="lead"><b>' + trans.help.rateLead + "</b><p>" + trans.help.rateText + "</p></div>"
        );

        this.$rateForm = $('<form class="form" />').appendTo(scrollable);
        this.$rateForm.submit((e) => {
            e.preventDefault();
            this.sendRating();

            return false;
        });

        const ratingRow = $('<div class="ratingcol"><div class="label">' + trans.help.rating + "</div></div>").appendTo(
            this.$rateForm
        );
        this.rating = new StarRating().appendTo(ratingRow);
        this.rating.onChange = () => this.checkButtonState();

        const descRow = $('<div class="formrow" />').appendTo(this.$rateForm);
        descRow.append('<div class="formcontrol edited textarea"><label>' + trans.help.howImprove + "</label></div>");
        this.$descriptionInput = $('<textarea name="descr" autocomplete="off" value=""></textarea>').appendTo(
            descRow.find("> .formcontrol")
        );

        this.$saveBtn = Ripple.bind(
            $('<button type="submit">' + trans.help.sendBtn + "</button>")
                .appendTo(this.$rateForm)
                .click((e) => {
                    e.preventDefault();
                    if (this.$saveBtn.hasClass("disabled") || this.$saveBtn.hasClass("loading")) {
                        e.stopPropagation();
                        return;
                    }

                    this.$rateForm.submit();
                })
        );
    }

    protected onBecomeVisible() {
        this.rating.setValue(undefined);
        this.$descriptionInput.val("");
        this.$saveBtn.removeClass("loading");
        this.checkButtonState();
    }

    protected onBecomeInvisible() {}

    private checkButtonState() {
        if (this.rating.getValue() === undefined) this.$saveBtn.addClass("disabled");
        else this.$saveBtn.removeClass("disabled");
    }

    private async sendRating() {
        const cmd: ICreateAppRatingCmd = {
            rating: this.rating.getValue()!,
            comment: this.$descriptionInput.val().length === 0 ? undefined : this.$descriptionInput.val(),
        };

        if (cmd.rating === undefined) return;

        this.$saveBtn.addClass("loading");
        try {
            await Factory.getInstance<FeedbackDao>(FeedbackDao).rate(cmd);
            Popup.show(trans.help.ratingSuccessful, () => {
                if (this.onGoBack !== undefined) {
                    this.onGoBack();
                }
            });
        } catch (ex) {
            logError(ex);
            this.$saveBtn.removeClass("loading");
            Popup.show(trans.help.failedRate);
        }
    }
}
